import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mainadmin',
  templateUrl: './mainadmin.component.html',
  styleUrls: ['./mainadmin.component.scss']
})
export class MainadminComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
